<template lang="pug">
div.toggle-dark-theme
    icon-weather-sunny(
        v-if="theme === 'dark'"
        v-on:click="onToggle"
        v-bind:title="$t('user.enabledDarkTheme')")
    icon-weather-night(
        v-else
        v-on:click="onToggle"
        v-bind:title="$t('user.disabledDarkTheme')")

</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const mapStateUx = createNamespacedHelpers('ux').mapState;

export default {
    name: 'toggle-dark-theme',

    computed: {
        ...mapStateUx({
            theme: state => state.theme
        })
    },

    methods: {
        /**
         * Toggle theme from the icon switch.
         * `this.theme` is the stored value, now the new value
         * is now emited to the bus, and saved to the store in main App.
         */
        onToggle: function () {
            const theme = this.theme === 'dark' ? 'default' : 'dark';
            this.$eventBus.$emit('app-theme-change', theme);
        }
    }
};
</script>

<style scoped lang="scss">
.toggle-dark-theme {
    .material-design-icon {
        width: 32px;
        height: 32px;
    }
}
</style>
